function initCalendar(calendarStart) {
    var calendar = $('#calendar');
    var lucidStaffItems = $(".lucid-staff");
    calendar.fullCalendar({
        now: calendarStart,
        viewRender: function (view, element) {
            calendar.fullCalendar('refetchEvents');
        },
        events: {
            url: '/calendar-source',
            data: {
                'users': getSelectedLucidStaff,
                'viewType': getViewType
            }
        },
        header: {
            left: 'prev,next today',
            center: 'title',
            right: 'month,basicWeek,basicDay'
        },
        dayNamesShort: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        timeFormat: "h(:mm)a",
    });
    lucidStaffItems.on("change", function (event) {
        calendar.fullCalendar('refetchEvents');
    });
    function getSelectedLucidStaff() {
        return lucidStaffItems.find(":checked")
            .map(function (index, selectedCheckbox) { return selectedCheckbox.value; })
            .get()
            .join("|");
    }
    function getViewType() {
        return calendar.fullCalendar('getView').type;
    }
}
//# sourceMappingURL=calendar.js.map